import React, { useEffect, useState } from "react";
import SEO from "../components/SEO";
import { Link } from "react-router-dom";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    // username: "",
    message: "",
  });

  //   useEffect(() => {
  //     const scriptURL =
  //       "https://script.google.com/macros/s/AKfycbxczOnNOfsDea4DBme1GX11x7rTkE5tJl7-nKe8y40Y-GhD99aoKhu3KNung-kl4SMF/exec";

  //     const form = document.forms["submit-to-google-sheet"];

  //     form.addEventListener("submit", (e) => {
  //       e.preventDefault();
  //       fetch(scriptURL, { method: "POST", body: new FormData(form) })
  //         .then((response) => {
  //           form.reset();
  //         })
  //         .catch((error) => console.error("Error!", error.message));
  //     });
  //   }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxczOnNOfsDea4DBme1GX11x7rTkE5tJl7-nKe8y40Y-GhD99aoKhu3KNung-kl4SMF/exec";
    const form = e.target;
    const formData = new FormData(form);
    console.log("Form Submitted:", formData);
    fetch(scriptURL, { method: "POST", body: formData })
      .then((response) => {
        form.reset();
        alert("Your message has been submitted!");
      })
      .catch((error) => console.error("Error!", error.message));
  };

  return (
    <>
      <SEO
        title="Contact Sustally | Support and Account Requests"
        description="Contact Sustally for support, account deletion requests, or general inquiries about sustainability and impact management."
        url="/contact-us"
      />

      <div className="flex items-center justify-center min-h-screen px-4 mt-12 dark:bg-[#121212]">
        <div className="w-full max-w-lg p-8 shadow-md rounded-2xl dark:bg-secondary-dark">
          <h1 className="mb-4 text-2xl font-bold text-center dark:text-white">
            Contact Us
          </h1>

          <p className="mb-3 text-sm text-center text-gray-600">
            To delete your account please mention the associated email/phone
            number below and mention <b className="text-lg">'Delete account'</b>{" "}
            in the message box with product name. Please know that your account
            will be deleted along with all data linked to the account.
          </p>

          <p className="mb-6 text-sm text-center text-gray-600">
            For more details please refer to the{" "}
            <Link to="/privacy-policy" className="!text-purple-600 !underline">
              privacy policy
            </Link>
            .
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block mb-1 font-medium dark:text-gray-400">
                Name:
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-transparent border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                required
              />
            </div>

            <div>
              <label className="block mb-1 font-medium dark:text-gray-400">
                Email:
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-transparent border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                required
              />
            </div>

            <div>
              <label className="block mb-1 font-medium dark:text-gray-400">
                Phone Number:
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-transparent border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            {/* <div>
              <label className="block mb-1 font-medium dark:text-gray-400">
                User Name:
              </label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className="w-full px-3 py-2 bg-transparent border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div> */}

            <div>
              <label className="block mb-1 font-medium dark:text-gray-400">
                Message:
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className="w-full px-3 py-2 bg-transparent border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                required
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full py-2 font-semibold text-white transition rounded-md bg-sustally-violet hover:bg-sustally-violet"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
